import {
  PersonEntry,
  PersonWrapperEntry,
} from "frontend/contentful/schema/semantics";
import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { RelatedPerson } from "design-system/components/pages/article-page/article-related-people/article-related-people";
import { createPersonImageProps } from "../primitives/media-asset.props";
import { useContentful } from "frontend/hooks/use-contentful";
import { isContentType } from "frontend/contentful/lib/is-content-type";
import { getPersonProps } from "../utils/get-person.props";

export const createArticleRelatedPersonProps = createContentfulProps<
  PersonEntry | PersonWrapperEntry,
  RelatedPerson
>(({ entry, createEditAttributes }) => {
  const { getPersonLink, getEntityName, getEntry } = useContentful();

  let personEntry: PersonEntry | undefined;

  if (isContentType<PersonWrapperEntry>("personWrapper", entry)) {
    personEntry = getEntry(entry.fields.person);
  } else {
    personEntry = entry;
  }

  const props: RelatedPerson = {
    name: getEntityName(entry),
    titles: getPersonProps(entry)?.titles || [],
    link: getPersonLink(entry),
    portrait: createPersonImageProps(entry),
    email: getPersonProps(entry)?.email,
    editAttributes: {
      name: createEditAttributes({ entry: personEntry, fieldId: "firstName" }),
      titles: createEditAttributes({
        entry: personEntry,
        fieldId: "jobTitles",
      }),
    },
  };
  return props;
});
